import React from 'react';
import HeroSection from '../components/HeroSection';

function Home() {
  return (
    <>
      <HeroSection />
      {/* 필요에 따라 추가 섹션 */}
    </>
  );
}

export default Home;